module.exports = __webpack_public_path__ + "media/images/close_tag_icon-85f4e9618aad8f9959eff22a00a58963.svg";